export default __webpack_public_path__ + "static/2.2_IT-b5e1eafd4e46e7bc0f3ccaf48d74e375.webp";